module.exports = __webpack_public_path__ + "static/media/header-minimal-logo-36x36.d881daf0.svg";